
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('g',[_c('path',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"d":"M21.75,12.75v9a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5v-9"}}),_c('line',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"x1":"2.25","y1":"17.25","x2":"15","y2":"17.25"}}),_c('line',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"x1":"15","y1":"23.25","x2":"15","y2":"12.75"}}),_c('path',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"d":"M.75,7.5a2.82,2.82,0,0,0,5.63,0A2.81,2.81,0,0,0,12,7.5a2.82,2.82,0,0,0,5.63,0,2.81,2.81,0,1,0,5.62,0h0L21.88,1.34a.75.75,0,0,0-.73-.59H2.85a.75.75,0,0,0-.73.59L.75,7.5Z"}})])])])
          )
        }
      }
    